<template>
  <div>
  <span  v-if="entrada">
  <Menu/>
  <Slider v-bind:tipo="$t('slider_adulto')" id="adulto"/>
<!-- ___________________ Croqueta ___________________ -->
  <div id="croqueta_nufit_adulto">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales 1"></div>
      <div class="content" >
        <h2 class="title1 paddingT80" uk-scrollspy="cls: uk-animation-fade; repeat: false">{{ $t('titulo1') }}</h2>
        <div class="uk-text-center" uk-parallax="stroke: 100%; viewport: 0.4">
          <img v-bind:src="$t('svg_adulto')" alt="" uk-svg class="escritorio">
          <img v-bind:src="$t('croqueta_adulto')" uk-svg alt="" class="movil"> 
        </div>
      </div>
      <div class="laterales 2"></div>  
    </div>
  </div>
<!-- ___________________ Beneficios Cachorro ___________________ -->
  <div id="beneficio_nufit_adulto" class="uk-background-cover">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales" uk-parallax="bgy: 300,-20; viewport: 1.5;" style="min-height:500px;">
             <img src="/public/img/nparallax/img_hojas_1.png" uk-parallax=" y: -50,300; viewport: 1.6" style=""/> 
      </div>
      <div class="content">
        <h2 class="title2 colorNaranja paddingT80" v-html="$t('beneficio_titulo_adulto')"></h2>
        <p class="text1 colorCafe"><span class="max600">{{ $t('beneficio_texto_adulto') }}</span></p>
        <div class="uk-grid uk-animation-fade" uk-scrollspy="cls: uk-animation-fade; target">
          <CardBeneficios v-for="n in 6" :key="n.id" 
          v-bind:info="[$t('beneficio_iconos_adulto['+(n-1)+']')]"/>
        </div>
      </div>
      <div class="laterales" uk-parallax="bgy: 300,-20; viewport: 1.5;" style="min-height:500px;background-repeat:no-repeat;">
        <img src="/public/img/nparallax/img_chicharos_3.png" uk-parallax=" y: 350,450; viewport: 1" style=""/> 
        <img src="/public/img/nparallax/img_chicharos_2.png" uk-parallax=" y: 150,0; viewport: 1" style=""/>
        <img src="/public/img/nparallax/img_chicharos_1.png" uk-parallax=" y: -700,-650; viewport: 1" style=""/> 
      </div>
    </div>
  </div>
  <div class="separador" uk-parallax="bgy: -300; bgx: -50;"><img src="/public/img/movil/_img_separador_mov_1.png"/> </div> <!-- ___________________ Presentacion ___________________ -->
<!-- ___________________ Presentacion Cachorro ___________________ -->
  <div id="presentacion_nufit_adulto" class="uk-background-cover" uk-parallax="bgy: -700">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales" uk-parallax="bgy: 100,-10000; bgx:50; scale: 0.8,1;" style="min-height:600px;">
        <img src="/public/img/nparallax/img_amaranto_1.png" uk-parallax="y: 200,-200; viewport: 1"/> 
      </div>
      <div class="content">
        <h2 class="title2 colorNaranja paddingT80" v-html="$t('presentacion_titulo_adulto')"></h2>
        <br>
        <img src="/public/img/recursos/img_nufit_pres_adulto.png" class="imgSacos" uk-scrollspy="cls: uk-animation-fade; target: .elementB; delay: 100; repeat: false">
        <br>
        <ul class="listImg" uk-scrollspy="cls: uk-animation-fade; target: .elementB; delay: 100; repeat: false">
          <li class="elementB"><img src="/public/img/recursos/img_25kg_adulto.png" alt=""> </li>
          <li class="elementB"><img src="/public/img/recursos/img_15kg_adulto.png" alt=""> </li>
          <li class="elementB"><img src="/public/img/recursos/img_8kg_adulto.png" alt=""> </li>
          <li class="elementB"><img src="/public/img/recursos/img_4kg_adulto.png" alt=""> </li>
          <li class="elementB"><img src="/public/img/recursos/img_2kg_adulto.png" alt=""> </li>
        </ul>
        <br><br><p class="text1 colorCafe" style="margin:0px;">{{ $t('alimentacion_titulo_adulto') }}</p>
      </div>
      <div class="laterales 3">
      </div>
    </div>
    
  </div>
  <!-- ___________________ Indicaciones Adulto ___________________ -->
  <div id="indicaciones_nufit_adulto" class="paddingT80" data-top="100">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales" uk-parallax="">
        <img src="/public/img/parallax/trigo.png" uk-parallax="opacity: 1; y: 0,-200; viewport: 0.5,0.9" style=""/> 
      </div>
      <div class="content" uk-scrollspy="cls: uk-animation-fade; target: .elementB; delay: 100; repeat: false">
        <div class="uk-grid">
          <div class="uk-width-1-1 uk-width-1-2@m elementB">
            <h2 class="title4 colorNaranja " v-html="$t('indicaciones_titulo_adulto')+':'"></h2> <br>
            <p class="text1 colorCafe">{{ $t('indicaciones_texto_adulto') }}</p>
            <h2 class="title4 colorNaranja" v-html="$t('dosis_titulo_adulto')+':'"></h2> <br>
            <p class="text1 colorCafe" v-html="$t('dosis_texto_adulto') "></p>
            <h2 class="title4 colorNaranja">{{ $t('via_titulo_adulto') }}:</h2> <br>
            <p class="text1 colorCafe">{{ $t('via_texto_adulto') }}</p>
            <div class="separador" uk-parallax="bgy: -300; bgx: -50;"><img src="/public/img/movil/_img_separador_mov_2.png"/> </div>
            <h2 class="title4 colorNaranja">{{ $t('recomendaciones_titulo_adulto') }}:</h2> <br>
            <p class="text1 colorCafe" v-html="$t('recomendaciones_texto_adulto')"></p>
            <h2 class="title4 colorNaranja" v-html="$t('advertencias_titulo_adulto')+':'"></h2> <br>
            <p class="text1 colorCafe" v-html="$t('advertencias_texto_adulto')"></p>
          </div>
          <div class="uk-width-1-1 uk-width-1-2@m elementB">
            <h2 class="title4 colorNaranja">{{ $t('ingredientes_titulo_adulto') }}:</h2> <br>
            <p class="text1 colorCafe" v-html="$t('ingredientes_texto_adulto')"></p>
          </div>
        </div>
        
      </div>
      <!-- <div class="laterales" uk-parallax="scale: .5,.7; bgy: -300, -600;bgx: -20,90; viewport: .9;" style="min-height:500px;background:url(/public/img/parallax/chicharos_back.png);
      background-repeat:no-repeat; background-position: center center!important;">
             <img src="/public/img/parallax/chicharos.png" uk-parallax="opacity: 1; y: -300,-600; viewport: 0.9" style=""/> 
      </div> -->
      <div class="laterales 5">
        <img src="/public/img/parallax/img_camote_3.png" uk-parallax="opacity: 1; y: 450,50; viewport: 0.9;" style="max-width:200px;"/> 
        <img src="/public/img/parallax/img_camote_2.png" uk-parallax="opacity: 1; y: 0,-450; viewport: 0.9;" style="max-width:200px;"/> 
        <img src="/public/img/parallax/img_camote_1.png" uk-parallax="opacity: 1; y: 0,-1300; viewport: 0.9;" style="max-width:200px;"/> 
      </div>
    </div>
      
      
  </div>

  <div class="separador" uk-parallax="bgy: -300; bgx: -50;"><img src="/public/img/movil/_img_separador_mov_2.png"/> </div>
  <!-- ___________________ Análisis Adulto  ___________________ -->
  <div id="analisis_garantizado_nufit_adulto" >
    <h2 class="title2 colorNaranja paddingT80">{{$t('analisis_titulo_adulto')}}</h2>
    <div class="uk-grid">
      <div class="uk-width-1-1 uk-width-1-2@m">
        <table class="tableV uk-table uk-table-small table1Analisis borderColorVerde">
          <tbody>
              <tr class="elementB">
                <td>{{$t('analisis_table_adulto[0].titulo')}}</td>
                <td>{{$t('analisis_table_adulto[6].titulo')}} 23.0%</td>
              </tr>
              <tr class="elementB">
                <td>{{$t('analisis_table_adulto[1].titulo')}}</td>
                <td>{{$t('analisis_table_adulto[6].titulo')}} 9.0%</td> 
              </tr>
              <tr class="elementB">
                <td>{{$t('analisis_table_adulto[2].titulo')}}</td>
                <td>{{$t('analisis_table_adulto[7].titulo')}} 4.0%</td>
              </tr>
          </tbody>
        </table>
      </div>
      <div class="uk-width-1-1 uk-width-1-2@m">
        <table class="tableV uk-table uk-table-small table2Analisis borderColorVerde">
          <tbody>
              <tr class="elementB"><td>{{$t('analisis_table_adulto[3].titulo')}}</td><td>{{$t('analisis_table_adulto[7].titulo')}} 12.0%</td></tr>
              <tr class="elementB"><td>{{$t('analisis_table_adulto[4].titulo')}}</td><td>{{$t('analisis_table_adulto[7].titulo')}} 8.0%</td></tr>
              <tr class="elementB"><td>{{$t('analisis_table_adulto[5].titulo')}}</td><td>44.0%</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- ___________________ Guia Adulto ___________________ -->
  <div id="guia_de_alimentacion_nufit_adulto">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales 6">
        <img src="/public/img/nparallax/img_nopal_3.png" uk-parallax=" y: 800,550; viewport: 0.9"/> 
        <img src="/public/img/nparallax/img_nopal_2.png" uk-parallax=" y: 200,100; scale: .7,.8; viewport: 0.9"/> 
        <img src="/public/img/nparallax/img_nopal_1.png" uk-parallax=" y: -400,-250; scale: .7,.8; viewport: 0.9"/> 
      </div>
      <div class="content">
        <h2 class="title2 colorNaranja paddingT80" v-html="$t('guia_titulo_adulto')"></h2>
        <p class="text1 colorCafe" v-html="$t('guia_texto_adulto')"></p>
        <div class="uk-flex uk-child-width-1-1@s uk-child-width-1-1@m">
          <div>
            <table class="tableVi uk-table uk-table-small borderColorVerde" style="margin: 0 auto;" >
              <tbody>
                  <tr class="elementB">
                    <td colspan="2">{{ $t('guia_table_adulto[0].titulo') }} </td>
                    <td colspan="2" v-html="$t('guia_table_adulto[1].titulo')"></td>
                  </tr>

                  <tr class="elementB">
                    <td>lbs</td>
                    <td>Kg</td>
                    <td>Kg</td>
                    <td>{{ $t('guia_table_adulto[2].titulo') }}</td>
                  </tr>
                  <tr class="elementB">
                    <td>2.2</td>
                    <td>1.0</td>
                    <td>0.040</td>
                    <td><sup>1</sup>&frasl;<sub>2</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td>8.8</td>
                    <td>4.0</td>
                    <td>0.110</td>
                    <td>1</td>
                  </tr>
                  <tr class="elementB">
                    <td>15.4</td>
                    <td>7.0</td>
                    <td>0.170</td>
                    <td>1 <sup>3</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td>22.0</td>
                    <td>10.0</td>
                    <td>0.220</td>
                    <td>2 <sup>1</sup>&frasl;<sub>5</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td>33.0</td>
                    <td>15.0</td>
                    <td>0.300</td>
                    <td>3</td>
                  </tr>
                  <tr class="elementB">
                    <td>44.0</td>
                    <td>20.0</td>
                    <td>0.370</td>
                    <td>3 <sup>3</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td>55.0</td>
                    <td>25.0</td>
                    <td>0.440</td>
                    <td>4 <sup>2</sup>&frasl;<sub>5</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td>66.0</td>
                    <td>30.0</td>
                    <td>0.500</td>
                    <td>5</td>
                  </tr>
                  <tr class="elementB">
                    <td>88.0</td>
                    <td>40.0</td>
                    <td>0.620</td>
                    <td>6 <sup>1</sup>&frasl;<sub>5</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td>110.0</td>
                    <td>50.0</td>
                    <td>0.730</td>
                    <td>7 <sup>1</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td>132.0</td>
                    <td>60.0</td>
                    <td>0.840</td>
                    <td>8 <sup>2</sup>&frasl;<sub>5</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td>154.0</td>
                    <td>70.0</td>
                    <td>0.940</td>
                    <td>9 <sup>2</sup>&frasl;<sub>5</sub></td>
                  </tr>
                  <tr class="elementB">
                    <td class="borderBN">176.0</td>
                    <td class="borderBN">80.0</td>
                    <td class="borderBN">1.040</td>
                    <td class="borderBN">10 <sup>2</sup>&frasl;<sub>5</sub></td>
                  </tr>

              </tbody>
            </table>
            <br/>
          </div>
          
        </div>
      </div>
      <div class="laterales" style="background-size:100%;background-repeat:no-repeat;">
        <img src="/public/img/parallax/trigo.png" uk-parallax="opacity: .8,1.2; y: 200,50,-100; viewport: 0.8"/> 
      </div>
    </div>
    
  </div>
  <!-- ___________________ Cachorro ___________________ -->
   <Cachorro />
  <!-- ___________________ Empaque ___________________ -->
  <div id="empaque" style="" >
    <div class="content" style="margin: 0 auto;">
      <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slideshow="autoplay: false; autoplay-interval: 2000">
        <div class="uk-slideshow-items">
            <div class="responsabilidaSlider">
              <div class="">
                <h2></h2>
                <p></p>
                <img :src="$t('empaque_img1')" alt="">
              
              </div>
            </div>
            <div class="responsabilidaSlider" v-for="n in 6" :key="n.id">
              <div class="">
                <h2 class="title1 colorCafe titleRes" uk-slideshow-parallax="x: 100,-100" v-html="$t('empaque_titulo'+n)"></h2>
                <p uk-slideshow-parallax="x: 200,-200" class="colorCafe"><span v-html="$t('empaque_texto'+n)"></span></p>
                <img :src="'/public/img/'+$t('empaque_carpeta')+'/img_sustentable_'+(n+1)+'.png'" />
              </div>
            </div>
        </div>
        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
      </div>
    </div>
  </div>
  <!--
  <div id="compra" style="background:white;margin:0px;" >
    <div class="content" style="margin: 0 auto;">
      <h2 class="title4"> <br> {{$t('donde_comprar_texto')}} </h2>
      <div class="uk-flex-center uk-flex-middle contLogos" style="padding:25px 0px;">
          <div style="min-width:50%;">
            <span class="weepecT">
              <a href="https://tienda.weepec.com/catalogsearch/result/?q=nufit" style="color:rgb(0, 165, 206);">
                <strong>tienda.weepec.com</strong><br>
                <img src="/public/img/Weepec_logo_.png" style="max-width:215px;">
              </a>
            </span>
          </div>
          <div style="min-width:50%;">
            <img src="/public/img/mas_kota_logo.png" style="width:300px;">
          </div>
   
      </div>
    </div>
  </div>
  -->
  <!-- ___________________ Footer ___________________ -->
  <div class="footer">
    <p class="text1 colorWhite" v-html="$t('textos_footer')">
    </p>
  </div>
  <!-- <div id="flotanteW" class="flotanteWeepec" >
      <a href="https://tienda.weepec.com/catalogsearch/result/?q=nufit" target="_blank" style="color:rgb(0, 165, 206);">
        <p>De venta en:</p>
        <img src="/public/img/Weepec_logo_.png" style="">
      </a>
    
    </div> -->

<!-- ___________________ Modal Camote ___________________ -->
  <div id="camote-CroquetaAdulto" uk-modal>
    <div class="uk-modal-dialog uk-modal-body modalIngredientes">
      <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-flex">
          <div class="uk-width-1-1" style="text-align:center;">
            <h2 class="title1">{{ $t('ingrediente_camote_titulo') }}</h2>
            <table>
            <tr>
              <td class="uk-width-1-6 uk-width-1-3@m">
                <img src="/public/img/_img_camote_ingredientes.png" alt="">
              </td>
              <td class="uk-width-5-6 uk-width-2-3@m" style="">
              <ul>
                <span class="text1" v-html="$t('ingrediente_camote_texto')"></span>
              </ul></td>
            </tr>
          </table>
          </div>
          
        </div>

    </div>
  </div>
<!-- ___________________ Modal Chihcaro ___________________ -->
  <div id="chicharo-CroquetaAdulto" uk-modal>
    <div class="uk-modal-dialog uk-modal-body modalIngredientes">
      <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-flex">
          <div class="uk-width-1-1" style="text-align:center;">
            <h2 class="title1">{{ $t('ingrediente_chicharo_titulo') }}</h2>
          <table>
            <tr>
          <td class="uk-width-1-6 uk-width-1-3@m ">
            <img src="/public/img/_img_chicharos_ingredientes.png" alt="">
          </td>
          <td class="uk-width-5-6 uk-width-2-3@m">
              <ul>
                <span class="text1" v-html="$t('ingrediente_chicharo_texto')"></span>
              </ul>
          </td></tr>
          </table>
          </div>
        </div>
    </div>
  </div>
  <div id="nopal-CroquetaAdulto" uk-modal>
    <div class="uk-modal-dialog uk-modal-body modalIngredientes">
      <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-flex">
          <div class="uk-width-1-1" style="text-align:center;">
            <h2 class="title1">{{ $t('ingrediente_nopal_titulo') }}</h2>
            <table>
            <tr>
          <td class="uk-width-1-6 uk-width-1-3@m ">
            <img src="/public/img/_img_nopal_ingredientes.png" alt="">
          </td>
          <td class="uk-width-5-6 uk-width-2-3@m">
              <ul>
                <span class="text1" v-html="$t('ingrediente_nopal_texto')"></span>
              </ul>
          </td></tr>
          </table>
          </div>
          
        </div>
    </div>
  </div>
  <div id="amaranto-CroquetaAdulto" uk-modal>
    <div class="uk-modal-dialog uk-modal-body modalIngredientes">
      <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-flex">
          <div class="uk-width-1-1" style="text-align:center;">
            <h2 class="title1">{{ $t('ingrediente_amaranto_titulo') }}</h2>
            <table>
            <tr>
          <td class="uk-width-1-6 uk-width-1-3@m ">
            <img src="/public/img/_img_amaranto_ingredientes.png" alt="">
          </td>
          <td class="uk-width-5-6 uk-width-2-3@m">
              <ul>
                <span class="text1" v-html="$t('ingrediente_amaranto_texto')"></span>
              </ul>
          </td></tr>
          </table>
          </div>
          
        </div>
    </div>
  </div>
  </span>
  
  <div class="uk-flex uk-height-viewport uk-flex-center uk-flex-middle uk-text-center" style="background: #5E3C32!important;" v-if="!entrada">
    <img src="/public/img/recursos/nufit_logo.png" uk-toggle="target: #my-id">
  </div>
  <div id="my-id" uk-modal>
      <div class="uk-modal-dialog uk-modal-body" style="background:white!important;">
          <h2 class="uk-modal-title"></h2>
            <fieldset class="uk-fieldset">

    <legend class="uk-legend">Usuario</legend>

    <div class="uk-margin">
        <input class="uk-input" type="text" v-model="usuario" style="max-width:50%;border:solid 1px black;"><br><br>
        <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>
    </div></fieldset>
          
      </div>
  </div> 
  

</div>
</template>

<style>
.Dnone{
  display: none;
}
.contLogos{
  display: flex;
}
.flotanteWeepec{
  position: fixed;
  right: 20px;
  bottom: 20px;
  background: rgba(255,255,255,.9);
  padding: 10px 5px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 0px 8px 4px rgba(0,0,0,0.22); 
  box-shadow: 0px 0px 8px 4px rgba(0,0,0,0.22);
}
.flotanteWeepec p{
  font-weight: bold;
  padding: 0px;
  margin: 0px;
}
.flotanteWeepec img{
  width: 100px;
}
.weepecT{
  padding: 10px 0px;
  -webkit-box-shadow: 0px 0px 8px 4px rgba(0,0,0,0); 
  box-shadow: 0px 0px 8px 4px rgba(0,0,0,0);
  display: block;
  border-radius: 8px;
}
.weepecT:hover{
  -webkit-box-shadow: 0px 0px 8px 4px rgba(0,0,0,0.22); 
  box-shadow: 0px 0px 8px 4px rgba(0,0,0,0.22);
}
img:not([src]){
  visibility: visible!important;
}
.uk-position-center-left svg, .uk-position-center-right svg{
  width: 25px;
}
.modalIngredientes{
  overflow: auto!important;
}
.modalIngredientes img{
  max-height: 350px;
}
.responsabilidaSlider .imgSlider{
  max-width: 670px;
  margin: 0px auto;
  background-size: 100%!important;
  display:block;background:url(/public/img/slider_sus_esp/img_sustentable_2.png) no-repeat;
  height:600px;
}
.responsabilidaSlider p{
  font-size: 18px;
}
.responsabilidaSlider h2{
  margin: 0px;
}
.responsabilidaSlider p span{
  max-width: 530px;
  display: block;
  margin: 0 auto;
}
.responsabilidaSlider img{
  max-width: 70%;
}
/* Generales */
  .uk-modal.uk-open{
    z-index: 9999;
  }
  .mr{
    font-size: 7px;
    vertical-align: super;
  }
  sup, sub{
    font-size: 10px;
  }
  .paddingT80{
    padding-top: 100px;
  }
  .paddingT90{
    padding-top: 80px;
  }
  .max600{
    max-width: 600px;
    display: block;
    margin: 0 auto;
  }
  .content{
    max-width: 940px;
    width: 66%;
  }
  .content1{
    max-width: 940px;
    width: 66%;
    margin: 0 auto;
  }
  .laterales{
    min-width: 250px;
    width: 17%;
    height: 300px;

  }
  .sublateral{
    background-image: url('/public/img/_img_hojas_1_izq.png');
    width: 100%;
    height: 100%;
    position: relative;
  }
  #bg1{
    background-image: url('/public/img/hoja.png');
  }
  #elemento1{
    position: absolute;
    right: 0px;
    z-index: 1;
  }
  .colorNaranja{
    color: #F68727;
  }
  .colorBlanco{
    color:white;
  }
  .colorCafe{
    color: #5E3C32!important;
  }
  .borderColorVerde, .borderColorVerde td{
    border-color: #86BB2B!important;
  }
  .borderColorMorado, .borderColorMorado td{
    border-color:#86BB2B!important;
  }
  .title1{
    font-size: 60px;
    color: #5F3C31;
    font-family: 'Satisfy', cursive;
  }
  .title2{
    font-size: 20px;
    font-weight: bold;
    font-family: 'Montserrat', sans-serif;
  }
  .title3{
    font-size: 16px;
    color: #5E3C32;
    font-weight: bold;
    margin: 0px;
    font-family: 'Montserrat', sans-serif;
  }
  .title4{
    font-size: 20px;
    font-weight: bold;
    margin: 0px;
    font-family: 'Montserrat', sans-serif;
  }
  .title5{
    font-size: 18px;
    color: white;
    font-weight: bold;
    margin: 0px;
  }
  .title6{
    font-size: 35px;
    font-family: 'Satisfy', cursive;
  }
  .text1{
    font-size: 16px;
    z-index: 99;
    margin-top: 0px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
  }
  .tableV, .tableVi{
    max-width: 330px;
    padding: 20px;
    margin: 5px;
  }
  .tableV tr, .tableV td{
    border: 3px solid;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    color: #5E3C32;
    font-weight: bold;
  }
  .tableVi tr, .tableVi tr:last-child{
    border-left: 1px transparent!important;
    border-left: 1px transparent!important;
  }
  .tableVi tr:last-child, .tableVi td:last-child{
    border-right: 1px transparent!important;
  }
  .borderBN{
    border-bottom: 1px transparent!important;
  }
  .borderTN{
    border-top: 1px transparent!important;
  }
  .tableVi td{
    border: 3px solid;
    border-left: 1px transparent!important;
    font-weight: bold;
    color: #5E3C32;
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
  }
  .table1Analisis{
    float: right;
  }
  .separador{
    display: none;
  }
  .imgSacos{
    max-width: 80%;
  }
  #empaque{
    background: #F68627;
    background-size: 100% 100%!important;
  }

  .listImg{
    padding: 0px;
    margin: 20px 0px 0px 0px;
  }
  .listImg li{
    display: inline-block;
    text-align: center;
    width: 19%;
    padding: 0px;
  }
  .listImg li img{
    padding: 5px;
  }
  .footer{
    background: #5E3D32;
    text-align: center;
    padding: 20px;
  }
  .footer p, .footer a{
    color: white;
    margin: 0px;
  }
  /* _____ Moda  */
  .uk-modal-dialog{
    width: 100%;
    height: 100%;
    position: relative;
    background: url('/public/img/recursos/ricepaper.jpg');
  }
  .uk-modal-dialog .uk-flex{
    max-width: 900px;
    margin: 0 auto;
    height: 100%;
    align-items: center;
  } 
  .uk-modal-dialog .uk-flex ul li{
    text-align: justify;
    padding-bottom: 15px;
  }
  .escritorio{
    display: block;
  }
  .movil, .movilTable{
    display: none;
  }
 #adulto{
   padding-top: 80px;
 } 
 #empaque{
   background: url('/public/img/nparallax/bg_sustentable1.jpg'); 
   padding: 20px 0px;
 }
  @media only screen and (max-width: 960px){
    .separador{
      display: block;
    }
    .content{
      width: 95%;
      
    }
    .laterales{
      display: none;
    }
  }
  @media only screen and (max-width: 720px){
  #adulto{
   padding-top: 60px;
  } 
  .table1Analisis, .table2Analisis{
    float: none;
    margin: 0 auto;
    margin-bottom: 10px!important;
  }
  .escritorio, .tableEscritotrio{
    display: none;
  }
  .movilTable{
    display: table;
  }
  .movil{
    display: block;
  }
  .titleRes{
    font-size: 30px;
  }
  #empaque{
   background: url('/public/img/nparallax/bgMo.jpg'); 
    background-size:cover!important;
  }
  #empaque .uk-slideshow-items{
    min-height: 300px!important;
  }
  .contLogos{
    flex-direction: column;
  }
  .contLogos div{
    margin: 10px;
  }
  }
</style>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Menu from '../components/Nav.vue'
import Slider from '../components/Slider.vue'
import Cachorro from '../components/Cachorro.vue'
import CardBeneficios from '../components/CardBeneficios.vue'
export default {
  name: 'Home',
  data() {
    return {
      entrada: true,
      usuario: '',
    };
  },
  mounted(){
    
    var util = UIkit.util;
    var el = util.$('#compra');

    UIkit.scrollspy(el, { repeat: true });
      
    util.on(el,'inview', function(){
      var element = document.getElementById("flotanteW");
      element.classList.add("Dnone");
    });
    util.on(el,'outview', function(){
      var element = document.getElementById("flotanteW");
      element.classList.remove("Dnone");
    });

  },
  components: {
    Menu,
    Slider,
    CardBeneficios,
    Cachorro
  },
  watch:{
    usuario: function () {
      let dataV=this;
      if(this.usuario == "weepec"){
        dataV.entrada = true;
        document.querySelector('.uk-modal-close').click();

      }
    }
  },
  methods: {
  
  }

}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue